import './Loader.css'

import { styled } from '@mui/material/styles'
import type { CSSProperties } from 'react'
import React from 'react'

interface LoaderProps {
  className?: string
  center?: boolean
}

const GradientStop = styled('stop')(({ theme }) => ({
  stopColor: theme.palette.primary.main
}))

const defaultStyles: CSSProperties = {
  margin: '0 auto',
  padding: '2vw',
  width: '7vw'
}

const centerStyles: CSSProperties = {
  left: '50%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 999
}

export default function Loader ({ className, center }: LoaderProps) {
  return <section className={className} style={center ? { ...defaultStyles, ...centerStyles } : defaultStyles}>
    <svg className="spinner" width="4%" height="4%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle className="path" fill="transparent" strokeWidth="2" cx="33" cy="33" r="30" stroke="url(#gradient)" />

      <linearGradient id="gradient">
        <GradientStop offset="50%" stopOpacity="1" />

        <GradientStop offset="65%" stopOpacity=".5" />

        <GradientStop offset="100%" stopOpacity="0" />
      </linearGradient>
    </svg>
  </section>
}
